import React, { Component } from "react";

export default class Receive extends Component {
  render() {
    const {
      isPurchaseOrder,
      purchaseOrder,
      vendor,
      vendors,
      dueDate,
      invoiceDate,
      onNumberChange,
      onVendorChange,
      onAmountChange,
      onDueDateChange,
      onInvoiceDateChange,
      submitInvoice,
      cancelInvoice,
      errors,
    } = this.props;
    return (
      <div className="card">
        <div className="card-header">
          <strong>New Invoice{isPurchaseOrder && ` for Purchase Order #${purchaseOrder}`}</strong>
        </div>
        <div className="card-block">
          <div className="row">
            <div className="col-sm-10 col-xl-6">
              <form>
                <div className={errors.indexOf("invoiceNumber") !== -1 ? "form-group row has-danger" : "form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Invoice Number
                  </label>
                  <div className="col-sm-8 input-group">
                    <div className="input-group-addon">#</div>
                    <input
                      type="text"
                      id="text-input"
                      name="text-input"
                      className={errors.indexOf("invoiceNumber") !== -1 ? "form-control form-control-danger" : "form-control"}
                      placeholder="Enter invoice number"
                      onChange={onNumberChange}
                    />
                  </div>
                </div>

                {isPurchaseOrder ? (
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label" htmlFor="text-input">
                      Vendor
                    </label>
                    <div className="col-sm-8 input-group">
                      <input type="text" id="text-input" name="text-input" className="form-control" disabled value={vendor} />
                    </div>
                  </div>
                ) : (
                  <div className={errors.indexOf("vendor") !== -1 ? "form-group row has-danger" : "form-group row"}>
                    <label className="col-sm-4 col-form-label" htmlFor="select">
                      Vendor
                    </label>
                    <div className="col-sm-8">
                      <select
                        id="select"
                        name="select"
                        className={errors.indexOf("vendor") !== -1 ? "form-control form-control-danger" : "form-control"}
                        size="1"
                        onChange={onVendorChange}
                      >
                        <option value="-1">Please select vendor</option>
                        {vendors.map((vendor, index) => {
                          return (
                            <option value={index} key={vendor.id}>
                              {vendor.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                )}

                <div className={errors.indexOf("totalAmount") !== -1 ? "form-group row has-danger" : "form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="text-input">
                    Total Amount
                  </label>
                  <div className={errors.indexOf("totalAmount") !== -1 ? "col-sm-8 input-group has-danger" : "col-sm-8 input-group"}>
                    <div className="input-group-addon">$</div>
                    <input
                      type="number"
                      id="text-input"
                      name="text-input"
                      min="1"
                      className="form-control"
                      placeholder="Total amount of the invoice"
                      onChange={onAmountChange}
                    />
                  </div>
                </div>

                <div className={errors.indexOf("invoiceDate") !== -1 ? "form-group row has-danger" : "form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="date">
                    Invoice Date
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="date"
                      id="date"
                      className={errors.indexOf("invoiceDate") !== -1 ? "form-control form-control-danger" : "form-control"}
                      value={invoiceDate}
                      onChange={(date) => onInvoiceDateChange(date)}
                    />
                  </div>
                </div>

                <div className={errors.indexOf("dueDate") !== -1 ? "form-group row has-danger" : "form-group row"}>
                  <label className="col-sm-4 col-form-label" htmlFor="date">
                    Due Date
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="date"
                      id="date"
                      className={errors.indexOf("dueDate") !== -1 ? "form-control form-control-danger" : "form-control"}
                      value={dueDate}
                      onChange={(date) => onDueDateChange(date)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="card-footer row mr-0 ml-0">
          <button type="submit" className="btn btn-primary col-xs-6" onClick={submitInvoice}>
            Submit
          </button>
          <button type="reset" className="btn btn-danger col-xs-6" onClick={cancelInvoice}>
            Cancel
          </button>
        </div>
      </div>
    );
  }
}
